import useDeleteDocumentForm from 'modules/documents/hooks/useDeleteDocumentForm';
import { toast } from 'react-toastify';
import DeleteConfirmationDrawer from '@library/drawer/components/DeleteConfirmationDrawer';
import { IDocumentFileModel } from '@api/models';

interface DeleteDocumentDrawerProps {
    show: boolean;
    onClose: () => void;
    file: IDocumentFileModel;
    onDelete: (fileId: string) => void;
}

const DeleteDocumentDrawer = (props: DeleteDocumentDrawerProps) => {
    const { show, onClose, file, onDelete } = props;

    const deleteDocumentForm = useDeleteDocumentForm({ file });

    const handleDelete = async () => {
        try {
            await deleteDocumentForm.submit();

            onDelete(file._id);

            toast.success('File deleted successfully.');

            onClose();
        } catch (err: any) {
            toast.error(err.data.message || 'Some error occurred, please try again');
        }
    };

    // if (!(hasPermission(PermissionEnum.DOCUMENT_DELETE) || (file?.uploadedBy as UserModel)?._id === user._id))
    //     return (
    //         <NoDeletePermissionDrawer
    //             show={show}
    //             onClose={onClose}
    //             title="Delete File"
    //             message="Only Admins are authorized to delete file."
    //         />
    //     );

    return (
        <DeleteConfirmationDrawer
            open={show}
            onClose={onClose}
            // message={<>Are you sure you want to delete this ticket?</>}
            message={
                <>
                    The following file <span className="text-grayscale-900">“{file?.name}”</span> will be deleted.
                </>
            }
            onConfirm={handleDelete}
            isConfirming={deleteDocumentForm.isLoading}
        />
    );
};

export default DeleteDocumentDrawer;
